import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, DialogActions, Typography } from '@mui/material';

import {
  closeBtn,
  dialogContent,
  dialogContentBoxes,
  dialogTitle,
  paperProps,
} from 'app/components/RequisiteModal/RequisiteModal.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import { black1 } from 'app/components/ThemeProvider/colors';
import { useTranslation } from 'react-i18next';

interface Props {
  open: any;
  close: any;
  dataDetails?: any;
}

const DetailsModal = (props: Props) => {
  const { open, close, dataDetails } = props;
  const { t } = useTranslation();

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => close(false)}
        aria-labelledby="alert-dialog-title-home-page"
      >
        <DialogTitle sx={dialogTitle}>
          <Typography sx={{ fontSize: '26px', fontWeight: 600 }}>
            {t('transactionsToBeSigned.paymentDetails')}
          </Typography>
          <Button
            color={'tertiary'}
            onClick={() => {
              close(false);
            }}
            sx={closeBtn}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogContent sx={dialogContent}>
          <Box sx={dialogContentBoxes} id={'requisiteData'}>
            {dataDetails?.details_data.map((item: any) => (
              <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }} key={item.title}>
                <Typography sx={{ fontSize: '15px', color: 'rgba(20, 25, 31, 0.60)', fontWeight: '400' }}>
                  {item.title}:
                </Typography>
                <Typography sx={{ fontSize: '16px', color: black1, fontWeight: '500' }}>{item.value}</Typography>
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ pl: '40px', pb: '40px', pr: '40px' }}>
          <Button onClick={() => close(false)} color={'tertiary'} sx={{ width: '100%' }}>
            {t('commonActions.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DetailsModal;
